<template>
  <b-modal
    id="addUser"
    size="lg"
    title="Agregar usuario"
    hide-footer
    @shown="onModalShown"
  >
    <form
      @submit.prevent="submit"
      v-promise-btn="{ action: 'submit' }"
      ref="form"
    >
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="Nombre_Usuario" class="label"
                >Nombre de usuario</label
              >
              <input
                type="text"
                class="form-control"
                name="nombre de usuario"
                id="Nombre_Usuario"
                v-model="usuario.nom_usuario"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="contrasena" class="label">Contraseña</label>
              <div class="input-group">
                <input
                  :type="showPassword ? 'text' : 'password'"
                  class="form-control"
                  name="contraseña"
                  id="contrasena"
                  v-model="usuario.contrasena"
                />
                <div class="input-group-addon">
                  <a @click="changeShowPassword"
                    ><i
                      :class="`fa fa-eye${!showPassword ? '' : '-slash'}`"
                      aria-hidden="true"
                    ></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="Apellido" class="label">Apellido</label>
              <input
                type="text"
                class="form-control"
                name="apellido"
                id="Apellido"
                v-model="usuario.apellido"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="Nombre" class="label">Nombre</label>
              <input
                type="text"
                class="form-control"
                name="nombre"
                id="Nombre"
                v-model="usuario.nombre"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="DNI" class="label">DNI</label>
              <input
                type="number"
                class="form-control"
                name="DNI"
                id="DNI"
                v-model="usuario.DNI"
              />
            </div>
          </div>

          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="tel-fijo" class="label">Telefono Fijo</label>
              <input
                type="number"
                class="form-control"
                name="telefono fijo"
                id="tel-fijo"
                v-model="usuario.tel_fijo"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="Cel-empresa" class="label">Celular empresa</label>
              <input
                type="number"
                class="form-control"
                name="celular empresa"
                id="Cel-empresa"
                v-model="usuario.Tel_celular_empresa"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="Cel-personal" class="label">Celular personal</label>
              <input
                type="number"
                class="form-control"
                name="celular personal"
                id="Cel-personal"
                v-model="usuario.tel_cel_personal"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="Provincia" class="label">Provincia</label>
              <input
                type="text"
                class="form-control"
                name="Provincia"
                id="Provincia"
                v-model="usuario.domicilio_prov"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="Cuidad" class="label">Ciudad</label>
              <input
                type="text"
                class="form-control"
                name="cuidad"
                id="Ciudad"
                v-model="usuario.domic_ciudad"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="Direccion" class="label">Dirección</label>
              <input
                type="text"
                class="form-control"
                name="Direccion"
                id="Direccion"
                v-model="usuario.domic_calleYnum"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="info-extra" class="label"
                >Info extra de direccion</label
              >
              <input
                type="text"
                class="form-control"
                name="info extra"
                id="info-extra"
                v-model="usuario.domic_infoExtra"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- </div> -->
      <div class="w-100 d-flex justify-content-end">
        <button
          type="button"
          class="btn btn-danger"
          @click="$bvModal.hide('addUser')"
        >
          Cancelar
        </button>
        <button type="submit" class="btn btn-primary">Guardar</button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import axios from "axios";
export default {
  name: "agregar-usuario",
  computed: {},
  data: () => ({
    showPassword: false,
    usuario: {
      nom_usuario: null,
      contrasena: null,
      nombre: null,
      apellido: null,
      DNI: "",
      tel_fijo: "",
      Tel_celular_empresa: "",
      tel_cel_personal: "",
      domicilio_prov: "",
      domic_ciudad: "",
      domic_calleYnum: "",
      domic_infoExtra: "",
    },
  }),

  methods: {
    changeShowPassword() {
      this.showPassword = !this.showPassword;
    },
    async submit() {
      if (!this.isValidForm()) {
        this.$msgBoxOk("Por favor, complete los campos correctamente");
        return;
      }

      try {
        let resp = await axios.post(`/execute`, {
          method: "SEC.CrearUsuario",
          parameters: [
            { name: "nom_usuario", value: this.usuario.nom_usuario },
            { name: "contrasena", value: this.usuario.contrasena },
            { name: "nombre", value: this.usuario.nombre },
            { name: "apellido", value: this.usuario.apellido },
            { name: "DNI", value: this.usuario.DNI },
            { name: "tel_fijo", value: this.usuario.tel_fijo },
            {
              name: "Tel_celular_empresa",
              value: this.usuario.Tel_celular_empresa,
            },
            { name: "tel_cel_personal", value: this.usuario.tel_cel_personal },
            { name: "domicilio_prov", value: this.usuario.domicilio_prov },
            { name: "domic_ciudad", value: this.usuario.domic_ciudad },
            { name: "domic_calleYnum", value: this.usuario.domic_calleYnum },
            { name: "domic_infoExtra", value: this.usuario.domic_infoExtra },
          ],
        });
        if (resp.data.ok) {
          this.$bvModal.hide("addUser");
          this.$emit("update");
          this.$bvToast.toast(resp.data.message, {
            variant: "success",
          });
        } else {
          this.$msgBoxOk(resp.data.message);
        }
      } catch (error) {
        console.error("Error al crear usuario:", error);
        this.$bvToast.toast("Error al crear usuario. Inténtelo nuevamente.", {
          variant: "danger",
        });
      }
    },
    isValidForm() {
      return (
        this.usuario.nom_usuario !== null &&
        this.usuario.contrasena !== null &&
        this.usuario.nombre !== null &&
        this.usuario.apellido !== null
      );
    },
    onModalShown() {
      this.usuario.nom_usuario = null;
      this.usuario.contrasena = null;
      this.usuario.nombre = null;
      this.usuario.apellido = null;
      this.usuario.DNI = "";
      this.usuario.tel_fijo = "";
      this.usuario.Tel_celular_empresa = "";
      this.usuario.tel_cel_personal = "";
      this.usuario.domicilio_prov = "";
      this.usuario.domic_ciudad = "";
      this.usuario.domic_calleYnum = "";
      this.usuario.domic_infoExtra = "";
    },
  },
};
</script>
<style scoped></style>
